<template>
  <vue-scroll>
    <rabbey-toolbox :call-new="callNew" />

    <RabbeyTable3
      :columns="columns"
      :data="items"
      style="margin: 20px"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />

    <el-drawer
      :title="tituloDrawer"
      :visible="openDetail"
      :size="sizedrawer"
      :before-close="CloseTransactionDetail"
    >
      <el-row :gutter="20" v-if="mostrardetalles">
        <el-col :offset="1">
          <h3>{{ textoTipo }}</h3>
          <span>{{ textoDescripcion }}</span>
        </el-col>
        <hr />
      </el-row>
      <el-form
        :model="DiscountFrom"
        :rules="rules"
        ref="DiscountFrom"
        label-width="120px"
        class="demo-ruleForm"
        :label-position="posionlabel"
        style="margin-left: 20px"
      >
        <el-row :gutter="20">
          <el-col :span="16"
            ><el-form-item :label="imputpreguntas" prop="types">
              <el-select
                v-model="DiscountFrom.types"
                placeholder="Seleccione el tipo de descuentos"
              >
                <el-option
                  v-for="item in DiscountTypesoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="%Aporte empleador">
              <el-input-number
                v-model="DiscountFrom.empleador"
                :controls="false"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="%Aporte colaborador">
              <el-input-number
                v-model="DiscountFrom.colaborador"
                :controls="false"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Tope anual">
              <el-input-number
                v-model="DiscountFrom.tope_anual"
                :controls="false"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Período de cobro" prop="periodo">
              <el-select v-model="DiscountFrom.periodo">
                <el-option label="Todos" value="Todos"></el-option>
                <el-option label="Primero" value="Primero"></el-option>
                <el-option label="Segundo" value="Segundo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="¿Descuento de ley?">
              <el-switch
                v-model="DiscountFrom.de_ley"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="¿DIVIDIR?">
              <el-switch
                v-model="DiscountFrom.dividir"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Cuenta de gasto">
              <el-input-number
                v-model="DiscountFrom.cuenta_gasto"
                :controls="false"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Cuenta por pagar">
              <el-input-number
                v-model="DiscountFrom.cuenta_cxp"
                :controls="false"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :offset="10"> </el-col>
          <el-col :span="20">
            <el-form-item label="Descripccion" v-if="mostrardescipccion">
              <el-input
                type="textarea"
                :rows="5"
                v-model="DiscountFrom.description"
                width="3000px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :offset="17">
            <el-button
              type="primary"
              @click="manageIncomeType()"
              v-if="mostrarbotonSurvey"
              >{{ this.BotonManage }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-drawer>
  </vue-scroll>
</template>

<script>
// import { formatDate } from "../../utils";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import RenderCheckLabelRequired from "@/components/functionals/RenderCheckLabelRequired.vue";
// import RenderCheckLabel from "@/components/functionals/RenderCheckLabel.vue";

export default {
  name: "DiscountsTypes",
  components: {
    RabbeyTable3
    // RenderCheckLabel
    // RenderCheckLabelRequired
  },
  data() {
    return {
      DiscountFrom: {
        id: 0,
        types: "",
        description: "",
        cuenta_gasto: 0.0,
        cuenta_cxp: 0.0,
        empleador: 0.0,
        colaborador: 0.0,
        tope_anual: 0.0,
        de_ley: false,
        dividir: false,
        periodo: ""
      },
      rules: {
        types: [
          {
            required: true,
            message: "Por favor Ingrese un titulo",
            trigger: "blur"
          }
        ],
        periodo: [
          {
            required: true,
            message: "Por favor Seleccione una plataforma.",
            trigger: "change"
          }
        ]
      },
      items: [],
      mostrarselect: false,
      title: "Crear tipo de descuento",
      drawer: false,
      isView: false,
      startedtime: false,
      isEdit: false,
      value1: true,
      mostrardetalles: true,
      // mostrartable: false,
      sizedrawer: "30%",
      id: 0,
      types: "",
      description: "",
      periodo: "",
      // viewselect:"inline-block",
      textoTipo: "",
      textoDescripcion: "",
      posionlabel: "",
      frecuencia: false,
      viewselect: false,
      mostrarbotonSurvey: false,
      mostarRequerido: true,
      mostrarEstatus: true,
      mostrartable: true,
      mostrarbotonquestion: false,
      checked: true,
      typebuttom: "el-icon-check",
      tituloDrawer: "Gestion de Preguntas ",
      openDetail: false,
      typerequest: 1,
      questionId: 0,
      No_Form: 0,
      mostrardescipccion: false,
      labelPosition: "right",
      mostrarselecttipo: true,
      imputpreguntas: "",
      itemsquestions: [],
      DescripccionEncuesta: "",
      DiscountTypesoptions: [
        {
          value: "DescEsp",
          label: "Descuentos Especiales"
        },
        {
          value: "INFOTEP",
          label: "Infotep"
        },
        {
          value: "Other_Discounts",
          label: "Otros Descuentos"
        }
      ],
      columns: [
        {
          prop: "Id",
          label: "id",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "types",
          label: "Tipo",
          minWidth: 100
        },
        {
          prop: "description",
          label: "Descripcion",
          minWidth: 150
        },
        {
          prop: "cuenta_gasto",
          label: "Cuenta de gasto",
          width: 150
        },
        {
          prop: "cuenta_cxp",
          label: "Cuenta por pagar",
          width: 150
        },
        {
          prop: "empleador",
          label: "Empleador",
          width: 100
        },
        {
          prop: "colaborador",
          label: "Colaborador",
          width: 100
        },
        {
          prop: "tope_anual",
          label: "Tope anual",
          width: 100
        },
        {
          prop: "de_ley",
          label: "De ley",
          width: 100,
          formatter: RenderCheckLabelRequired
        },
        {
          prop: "dividir",
          label: "Dividir",
          width: 100,
          formatter: RenderCheckLabelRequired
        },
        {
          prop: "periodo",
          label: "Periodo",
          width: 100
        }
      ],
      actions: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          label: "Eliminar",
          icon: "el-icon-delete",
          command: "delete"
        }
      ]
    };
  },
  computed: {
    params() {
      return {
        companyId: this.currentCompany
      };
    }
  },
  created() {
    this.getDiscountTypes();
  },
  methods: {
    resetForm1(formName) {
      this.$refs[formName].resetFields();
    },
    resetForm() {
      this.DiscountFrom.id = 0;
      this.DiscountFrom.types = "";
      this.DiscountFrom.description = "";
      this.DiscountFrom.cuenta_gasto = 0.0;
      this.DiscountFrom.cuenta_cxp = 0.0;
      this.DiscountFrom.empleador = 0.0;
      this.DiscountFrom.colaborador = 0.0;
      this.DiscountFrom.tope_anual = 0.0;
      this.DiscountFrom.de_ley = false;
      this.DiscountFrom.dividir = false;
      this.DiscountFrom.periodo = "";
      this.isEdit = false;
    },
    CloseTransactionDetail() {
      this.openDetail = false;
      this.resetForm();
    },
    getDiscountTypes() {
      this.$http
        .get("/api/Payroll/GetDiscountTypesMaintenance")
        .then((resp) => {
          this.items = resp.data;
        });
    },
    PostIncomeType() {
      const params = {
        types: this.DiscountFrom.types,
        description: this.DiscountFrom.description,
        cuenta_gasto: this.DiscountFrom.cuenta_gasto,
        cuenta_cxp: this.DiscountFrom.cuenta_cxp,
        empleador: this.DiscountFrom.empleador,
        colaborador: this.DiscountFrom.colaborador,
        tope_anual: this.DiscountFrom.tope_anual,
        de_ley: this.DiscountFrom.de_ley,
        dividir: this.DiscountFrom.dividir,
        periodo: this.DiscountFrom.periodo
      };
      this.$refs["DiscountFrom"].validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/Payroll/InsertDiscountTypes", params)
            .then(() => {
              this.$message.success("Agregado correctamente");
              this.getDiscountTypes();
              this.resetForm();
              this.mostrardetalles = false;
              this.CloseTransactionDetail();
            });
        }
      });
    },
    PutIncomeType() {
      const params = {
        Id: this.DiscountFrom.id,
        types: this.DiscountFrom.types,
        description: this.DiscountFrom.description,
        cuenta_gasto: this.DiscountFrom.cuenta_gasto,
        cuenta_cxp: this.DiscountFrom.cuenta_cxp,
        empleador: this.DiscountFrom.empleador,
        colaborador: this.DiscountFrom.colaborador,
        tope_anual: this.DiscountFrom.tope_anual,
        de_ley: this.DiscountFrom.de_ley,
        dividir: this.DiscountFrom.dividir,
        periodo: this.DiscountFrom.periodo
      };
      this.$refs["DiscountFrom"].validate((valid) => {
        if (valid) {
          this.$http
            .put("/api/Payroll/updateDiscountTypes", params)
            .then(() => {
              this.$message.success("Agregado correctamente");
              this.getDiscountTypes();
              this.resetForm();
              this.mostrardetalles = false;
              this.CloseTransactionDetail();
            });
        }
      });
    },
    DelIDiscountsTypes() {
      this.$http
        .delete("/api/Payroll/deleteDiscountTypes?id=" + this.DiscountFrom.id)
        .then(() => {
          this.$message.success("Eliminado correctamente");
          this.getDiscountTypes();
          this.resetForm();
          this.mostrardetalles = false;
          this.CloseTransactionDetail();
        });
    },
    manageIncomeType() {
      if (this.isEdit == true) {
        this.PutIncomeType();
      } else {
        this.PostIncomeType();
      }
    },
    callNew() {
      this.startedtime = true;
      this.BotonManage = "Guardar";
      this.sizedrawer = "30%";
      this.tituloDrawer = "Crear tipo de descuento";
      this.openDetail = true;
      this.mostrarTag = false;
      this.mostrarbotonquestion = false;
      this.isView = false;
      this.viewselect = false;
      this.mostrardetalles = false;
      this.posionlabel = "top";
      this.isEdit = false;
      this.imputpreguntas = "Tipo";
      this.drawer = true;
      this.mostrardescipccion = true;
      this.mostrarbotonSurvey = true;
      this.frecuencia = true;
    },
    handlePushAction(command) {
      switch (command.command) {
        case "view":
          this.isView = true;
          this.openDetail = true;
          break;

        case "edit":
          this.startedtime = true;
          this.BotonManage = "Editar";
          this.sizedrawer = "30%";
          this.tituloDrawer = "Editar tipo de descuento";
          this.openDetail = true;
          this.mostrarTag = false;
          this.mostrarbotonquestion = false;
          this.isView = false;
          this.viewselect = false;
          this.mostrardetalles = false;
          this.posionlabel = "top";
          this.isEdit = true;
          this.imputpreguntas = "Tipo";
          this.drawer = true;
          this.mostrardescipccion = true;
          this.mostrarbotonSurvey = true;
          this.DiscountFrom.id = command.row.Id;
          this.DiscountFrom.types = command.row.types;
          this.DiscountFrom.description = command.row.description;
          this.DiscountFrom.cuenta_gasto = command.row.cuenta_gasto;
          this.DiscountFrom.cuenta_cxp = command.row.cuenta_cxp;
          this.DiscountFrom.empleador = command.row.empleador;
          this.DiscountFrom.colaborador = command.row.colaborador;
          this.DiscountFrom.tope_anual = command.row.tope_anual;
          this.DiscountFrom.de_ley = command.row.de_ley;
          this.DiscountFrom.dividir = command.row.de_ley;
          this.DiscountFrom.periodo = command.row.periodo;
          break;
        case "delete":
          this.DiscountFrom.id = command.row.Id;
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              this.DelIDiscountsTypes();
            })
            .catch(() => {
              this.$message.info("Eliminacion cancelada");
            });
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style>
.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
}

.centered-tag {
  font-size: 1em;
  /* Ajusta el tamaño del texto según tus necesidades */
  /* Estilos adicionales del tag si es necesario */
}

.custom-form .el-form-item__label {
  display: none;
  /* Oculta la etiqueta predeterminada */
}

.custom-form .custom-label {
  display: block;
  font-weight: bold;
  /* Otras propiedades de estilo según tus preferencias */
  margin-bottom: 8px;
  /* Ajusta el margen inferior según tus necesidades */
}

.el-form-item__label {
  font-weight: bold;
  /* Otras propiedades de estilo según tus preferencias */
}
</style>
